import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useFileResources(userId) {
  const [files, setFiles] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.super_admins.personalFiles.index, {
        params: {
          user_id: userId,
        },
      })
      .then((response) => {
        setFiles(response.data.data);
      });
  }, []);

  return files;
}
